/**
 * ライブ音声ルーム定義（すべて誰でも入室可）
 * hostName / hostEmoji: 公式ルームのホスト表示用
 */

export const OFFICIAL_HOST = { name: 'JTALK', emoji: '✦' };

export const TALK_NORMAL_ROOMS = [
  {
    id: 'lobby',
    title: 'フリートーク',
    desc: '誰でも参加OK。気軽に音声で話しましょう',
    glyph: 'lobby',
    gradient: 'linear-gradient(135deg, rgba(201,168,76,0.18) 0%, rgba(232,208,138,0.08) 100%)',
    host: OFFICIAL_HOST,
  },
  {
    id: 'ja-practice',
    title: '日本語で話す',
    desc: '日本語学習・会話の練習用',
    glyph: 'ja',
    gradient: 'linear-gradient(135deg, rgba(180,140,60,0.16) 0%, rgba(201,168,76,0.07) 100%)',
    host: OFFICIAL_HOST,
  },
];

export const TALK_PREMIUM_ROOMS = [
  {
    id: 'english-lounge',
    title: 'English Lounge',
    desc: '英語で会話・リスニング練習',
    glyph: 'en',
    gradient: 'linear-gradient(135deg, rgba(120,100,200,0.14) 0%, rgba(201,168,76,0.07) 100%)',
    host: OFFICIAL_HOST,
  },
  {
    id: 'late-night',
    title: '深夜の語り',
    desc: '落ち着いたトーンでゆるく話す',
    glyph: 'night',
    gradient: 'linear-gradient(135deg, rgba(40,20,80,0.35) 0%, rgba(80,50,120,0.15) 100%)',
    host: OFFICIAL_HOST,
  },
];

const ALL_LIVE_ROOMS = [...TALK_NORMAL_ROOMS, ...TALK_PREMIUM_ROOMS];

const LIVE_TITLES = Object.fromEntries(ALL_LIVE_ROOMS.map((r) => [r.id, r.title]));

export function getLiveTalkRoomTitle(roomId) {
  return LIVE_TITLES[roomId] || roomId;
}

export function getLiveTalkRoomDesc(roomId) {
  return ALL_LIVE_ROOMS.find((r) => r.id === roomId)?.desc || '';
}
